let elements = {
  // playOnEnd: true,
  autoCheck: false,
  restoreColor: true, // cannot be used with blockWrongColor
  audio: {
    negative: 'games/page023_game1/audio/false.mp3',
    // positive: 'games/page023_game1/audio/true.mp3',
    click: 'games/page023_game1/audio/click.mp3',
  },
  image: {
    trImage: 'games/page023_game3/img/img_t3.webp',
    srcImage: 'games/page023_game3/img/img_o3.png',
    srcMask: 'games/page023_game3/img/img_m.png',
    width: 1920,
    height: 1080,
    // if colors is array of objects (not a single object), blockWrongColor must be false (default)
    colors: {
      1: '#000000',
      2: '#75b840',
      3: '#75b840',
      4: '#75b840',
    },
    // colors: {
    //   1: '#000000',
    //   2: '#75b840',
    //   3: '#75b840',
    //   4: '#75b840',
    //   5: '#75b840',
    //   6: '#75b840',
    //   7: '#75b840',
    //   8: '#75b840',
    //   9: '#75b840',
    //   10: '#75b840',
    //   11: '#75b840',
    //   12: '#75b840',
    //   13: '#75b840',
    //   14: '#75b840',
    //   15: '#75b840',
    //   16: '#75b840',
    //   17: '#75b840',
    //   18: '#75b840',
    //   19: '#75b840',
    //   20: '#75b840',
    //   21: '#75b840',
    //   22: '#75b840',
    //   23: '#75b840',
    //   24: '#75b840',
    //   25: '#75b840',
    //   26: '#75b840',
    //   27: '#75b840',
    //   28: '#75b840',
    //   29: '#75b840',
    //   30: '#75b840',
    //   31: '#75b840',
    //   32: '#75b840',
    //   33: '#75b840',
    //   34: '#75b840',
    //   35: '#75b840',
    //   36: '#75b840',
    //   37: '#75b840',
    //   38: '#75b840',
    //   39: '#75b840',
    //   40: '#75b840',
    //   41: '#75b840',
    //   42: '#75b840',
    //   43: '#75b840',
    //   44: '#75b840',
    //   45: '#75b840',
    //   46: '#75b840',
    //   47: '#75b840',
    //   48: '#75b840',
    //   49: '#75b840',
    //   50: '#75b840',
    //   51: '#75b840',
    //   52: '#75b840',
    //   53: '#75b840',
    //   54: '#75b840',
    //   55: '#75b840',
    //   56: '#75b840',
    //   57: '#75b840',
    //   58: '#75b840',
    //   59: '#75b840',
    //   60: '#75b840',
    //   61: '#75b840',
    //   62: '#75b840',
    //   63: '#75b840',
    //   64: '#75b840',
    //   65: '#75b840',
    //   66: '#75b840',
    //   67: '#75b840',
    //   68: '#75b840',
    //   69: '#75b840',
    //   70: '#75b840',
    //   71: '#75b840',
    //   72: '#75b840',
    //   73: '#75b840',
    //   74: '#75b840',
    //   75: '#75b840',
    //   76: '#75b840',
    //   77: '#75b840',
    //   78: '#75b840',
    //   79: '#75b840',
    //   80: '#75b840',
    //   81: '#75b840',
    //   82: '#75b840',
    //   83: '#75b840',
    //   84: '#75b840',
    //   85: '#75b840',
    // },
    cssStyle: {
      position: 'absolute',
      left: '0px',
      top: '0px',
      height: '1080px',
      width: '1920px',
    },
  },
  palette: {
    colors: [
      // {
      //   audioId: 'a1',
      //   val: '#75b840',
      //   audio: 'games/page023_game1/audio/35_three.mp3',
      //   cssStyle: {
      //     position: 'absolute',
      //     left: '52.8%',
      //     top: '69.4%',
      //     width: '8.2%',
      //     height: '20%',
      //     transform: 'rotate(0deg)',
      //     'border-radius': '50%',
      //     // 'background-color': 'rgba(83,187,63,0.4)',
      //   },
      // },
      {
        audioId: 'a1',
        val: '#75b840', // green
        waitingToBeClicked: { src: 'games/page033_game1/img/green.png' },
        clicked: { src: 'games/page033_game1/img/green_p.png' },
        cssStyle: {
          position: 'absolute',
          left: '50.5%',
          top: '76.5%',
          width: '3.2%',
          height: '5.8%',
          transform: 'rotate(0deg)',
          'border-radius': '0%',
          // 'background-color': 'rgba(83,187,63,0.4)',
        },
      },
    ],
    mbPaletteAudioItemData: [
      {
        id: 'a1',
        src: 'games/page023_game1/audio/35_three.mp3',
        audioConfig: {
          autoplay: false,
          loop: false,
          volume: 1,
        },
        iconConfig: {
          src: { iconOn: 'games/page023_game1/img/audioOn.png', iconOff: 'games/page023_game1/img/audioOff.png' },
          fill: 'none',
        },
        width: '46px',
        height: '46px',
        pos: {
          y: 11,
          x: 239,
        },
        unit: 'px',
      },
    ],
  },
};

export default elements;
